import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { SELECTED_BG, SELECTED_FG, SELECTED_BG_HOVER } from '../config/uiTheme';

// Per Nilsson bass model, three mutually exclusive modes:
//  'none'   - no bass at all (only the chord tones in the register window)
//  'static' - pedal point on the scale tonic
//  'follow' - the bass tracks each chord's own root
const OPTIONS = [
  { value: 'none', label: 'No' },
  { value: 'static', label: 'Static' },
  { value: 'follow', label: 'Follow chords' },
];

// Shared between the chord-config popover and Settings so both drive the same
// preference with an identical control.
const BassModeSelector = ({ value, onChange }) => (
  <ToggleButtonGroup
    exclusive
    fullWidth
    size="small"
    value={value}
    onChange={(e, next) => { if (next) onChange(next); }}
    sx={{
      '& .MuiToggleButton-root': {
        textTransform: 'none',
        fontWeight: 700,
        fontSize: '0.8rem',
        py: 0.75,
        color: 'rgba(255, 255, 255, 0.6)',
        borderColor: 'rgba(255, 255, 255, 0.12)',
        '&.Mui-selected': {
          color: SELECTED_FG,
          backgroundColor: SELECTED_BG,
          '&:hover': { backgroundColor: SELECTED_BG_HOVER },
        },
      },
    }}
  >
    {OPTIONS.map((o) => (
      <ToggleButton key={o.value} value={o.value} aria-label={o.label}>
        {o.label}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);

export default BassModeSelector;
